import React, { Component } from "react";
import "./SolicitudModal.css";
import { toast } from "react-toastify";
import SpinnerModal from "../../spiner/SpinnerModal";
import { getListaGeneralLocaciones } from "../../../service/api";

const VIA_OPTIONS = [
  { value: "Aérea", label: "Aérea" },
  { value: "Marítima", label: "Marítima" },
  { value: "Terrestre", label: "Terrestre" },
];

export default class SolicitudModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...this.getInitialState(props),
      locaciones: [],
      loadingLoc: false,
    };
  }

  componentDidMount() {
    this.loadLocaciones();
  }

  componentDidUpdate(prevProps) {
    const openedNow = !prevProps.show && this.props.show;
    const changedItem = prevProps.solicitud !== this.props.solicitud;
    const changedMode = prevProps.mode !== this.props.mode;
    const changedFechaPage = prevProps.fechaPage !== this.props.fechaPage;
    const changedNacionalidades =
      prevProps.array_nacionalidad !== this.props.array_nacionalidad;

    if (
      openedNow ||
      changedItem ||
      changedMode ||
      changedFechaPage ||
      changedNacionalidades
    ) {
      this.setState({
        ...this.getInitialState(this.props),
      });
    }
  }

  loadLocaciones = async () => {
    try {
      this.setState({ loadingLoc: true });

      const res = await getListaGeneralLocaciones();

      const data = Array.isArray(res?.data)
        ? res.data
        : Array.isArray(res?.data?.data)
        ? res.data.data
        : [];

      const locaciones = (data || [])
        .filter((x) => Number(x?.idestatus) === 1)
        .map((x) => ({
          idlocacion: x.idlocacion,
          locacion: x.locacion,
          idestatus: x.idestatus,
          estatus: x.estatus,
        }));

      this.setState({ locaciones });
    } catch (e) {
      toast.info("No se pudo cargar la lista de locaciones.");
      this.setState({ locaciones: [] });
    } finally {
      this.setState({ loadingLoc: false });
    }
  };

  toISODate(dateObj) {
    const y = dateObj.getFullYear();
    const m = String(dateObj.getMonth() + 1).padStart(2, "0");
    const d = String(dateObj.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  }

  normalizeISO = (v) => {
    const s = String(v ?? "").trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
    return "";
  };

  getInitialState = (props) => {
    const {
      mode = "create",
      solicitud,
      fechaPage,
      array_nacionalidad = [],
    } = props || {};

    const defaultFecha = this.normalizeISO(fechaPage) || this.toISODate(new Date());
    const defaultMoneda = "MXN";

    if (mode === "edit" && solicitud) {
      const idlocacion = String(solicitud?.idlocacion ?? "");
      const locacion = String(solicitud?.locacion ?? "");

      const idnacionalidad = Number(solicitud?.idnacionalidad ?? 0);

      const nacionalidadEncontrada = (
        Array.isArray(array_nacionalidad) ? array_nacionalidad : []
      ).find((n) => Number(n?.idnacionalidad) === idnacionalidad);

      const nacionalidadText = String(
        nacionalidadEncontrada?.nacionalidad ?? solicitud?.nacionalidad ?? ""
      ).trim();

      return {
        ticket: String(solicitud?.idticket ?? ""),
        fecha_transito:
          this.normalizeISO(solicitud?.fecha_transito) || defaultFecha,
        nombre: solicitud?.nombre ?? "",
        apellido: solicitud?.apellido ?? "",
        nacionalidad: nacionalidadText,
        idnacionalidad: idnacionalidad > 0 ? String(idnacionalidad) : "",
        pasaporte: solicitud?.pasaporte ?? "",
        via: this.normalizeVia(solicitud?.via),
        idlocacion,
        locacion,

        cantidad: String(solicitud?.cantidad ?? ""),
        moneda: String(solicitud?.moneda ?? defaultMoneda),

        carpeta: String(solicitud?.carpeta ?? ""),
        comentarios: String(solicitud?.comentarios ?? ""),
      };
    }

    return {
      ticket: "",
      fecha_transito: defaultFecha,
      nombre: "",
      apellido: "",
      nacionalidad: "",
      idnacionalidad: "",
      pasaporte: "",
      via: "",

      idlocacion: "",
      locacion: "",

      cantidad: "",
      carpeta: "",
      comentarios: "",
      moneda: defaultMoneda,
    };
  };

  isEmpty = (v) => String(v ?? "").trim() === "";

  onLocSelect = (idValue) => {
    const idlocacion = String(idValue || "");
    const found = (this.state.locaciones || []).find(
      (l) => String(l?.idlocacion) === idlocacion
    );

    this.setState({
      idlocacion,
      locacion: String(found?.locacion || ""),
    });
  };

  onNacSelect = (idValue) => {
    const idnacionalidad = String(idValue || "");
    const found = (Array.isArray(this.props.array_nacionalidad)
      ? this.props.array_nacionalidad
      : []
    ).find((n) => String(n?.idnacionalidad) === idnacionalidad);

    this.setState({
      idnacionalidad,
      nacionalidad: String(found?.nacionalidad || ""),
    });
  };

  limitValue = (value, max) => String(value ?? "").slice(0, max);

  onChangeLimited = (field, max) => (e) => {
    const v = this.limitValue(e.target.value, max);
    this.setState({ [field]: v });
  };

  onChangeCantidad = (e) => {
    let v = String(e.target.value ?? "");
    v = v.replace(/[^\d.,]/g, "");
    v = this.limitValue(v, 20);
    this.setState({ cantidad: v });
  };

  validate = () => {
    const s = this.state;

    if (this.isEmpty(s.ticket)) return "El ticket es requerido.";
    if (this.isEmpty(s.fecha_transito))
      return "La fecha de tránsito es requerida (YYYY-MM-DD).";
    if (!/^\d{4}-\d{2}-\d{2}$/.test(String(s.fecha_transito).trim()))
      return "Formato inválido de fecha (YYYY-MM-DD).";

    if (this.isEmpty(s.nombre)) return "El nombre es requerido.";
    if (this.isEmpty(s.apellido)) return "El apellido es requerido.";
    if (this.isEmpty(s.idnacionalidad)) return "La nacionalidad es requerida.";
    if (this.isEmpty(s.pasaporte)) return "El pasaporte es requerido.";
    if (this.isEmpty(s.via)) return "La vía es requerida.";
  //  if (this.isEmpty(s.carpeta)) return "Falta carpeta.";
    if (this.isEmpty(s.idlocacion)) return "La locación es requerida.";
    if (this.isEmpty(s.cantidad)) return "La cantidad es requerida.";

    const cant = Number(String(s.cantidad).replaceAll(",", "."));
    if (Number.isNaN(cant) || cant <= 0)
      return "La cantidad debe ser un número mayor a 0.";

    if (this.isEmpty(s.moneda)) return "La moneda es requerida.";

    return null;
  };

  normalizeVia = (v) => {
    const val = String(v || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");

    if (val.includes("aer")) return "Aérea";
    if (val.includes("mar")) return "Marítima";
    if (val.includes("terr")) return "Terrestre";

    return "";
  };

  onSubmit = () => {
    const { onSave, mode, solicitud } = this.props;

    const err = this.validate();
    if (err) {
      toast.info(err);
      return;
    }

    const cant = Number(String(this.state.cantidad).replaceAll(",", "."));

    const payload = {
      ticket: String(this.state.ticket).trim(),
      fecha_transito: String(this.state.fecha_transito).trim(),
      nombre: String(this.state.nombre).trim(),
      apellido: String(this.state.apellido).trim(),
      idnacionalidad: this.isEmpty(this.state.idnacionalidad)
        ? null
        : Number(this.state.idnacionalidad),
      nacionalidad: String(this.state.nacionalidad).trim(),
      pasaporte: String(this.state.pasaporte).trim(),
      via: String(this.state.via).trim(),

      idlocacion: this.isEmpty(this.state.idlocacion)
        ? null
        : Number(this.state.idlocacion),
      locacion: String(this.state.locacion).trim(),

      carpeta: String(this.state.carpeta).trim(),
      comentarios: String(this.state.comentarios).trim(),

      cantidad: cant,
      moneda: String(this.state.moneda).trim(),
    };

    onSave?.(payload, mode, solicitud);
  };

  render() {
    const { show, onClose, loading, mode } = this.props;
    if (!show) return null;

    const busy = loading || this.state.loadingLoc;
    const nacionalidades = Array.isArray(this.props.array_nacionalidad)
      ? this.props.array_nacionalidad
      : [];

    return (
      <div className="sm-backdrop">
        <div className="sm-modal" onClick={(e) => e.stopPropagation()}>
          {busy ? <SpinnerModal show={true} /> : null}

          <div className="sm-head">
            <h2 className="sm-title">
              {mode === "edit" ? "Editar Solicitud" : "Nueva Solicitud"}
            </h2>
            <button
              className="sm-x"
              type="button"
              onClick={onClose}
              disabled={busy}
              aria-label="Cerrar"
            >
              ✕
            </button>
          </div>

          <div className="sm-body">
            <div className="sm-grid">
              <div className="sm-field">
                <label>Ticket *</label>
                <input
                  value={this.state.ticket}
                  onChange={this.onChangeLimited("ticket", 10)}
                  placeholder="193852"
                  disabled={busy}
                />
              </div>

              <div className="sm-field">
                <label>Fecha tránsito *</label>
                <input
                  type="date"
                  value={this.state.fecha_transito}
                  onChange={(e) =>
                    this.setState({ fecha_transito: e.target.value })
                  }
                  disabled={busy}
                />
              </div>

              <div className="sm-field">
                <label>Nombre *</label>
                <input
                  value={this.state.nombre}
                  onChange={this.onChangeLimited("nombre", 35)}
                  placeholder="Juan"
                  disabled={busy}
                />
              </div>

              <div className="sm-field">
                <label>Apellido *</label>
                <input
                  value={this.state.apellido}
                  onChange={this.onChangeLimited("apellido", 35)}
                  placeholder="Perez"
                  disabled={busy}
                />
              </div>

              <div className="sm-field">
                <label>Nacionalidad *</label>
                <select
                  value={String(this.state.idnacionalidad || "")}
                  onChange={(e) => this.onNacSelect(e.target.value)}
                  disabled={busy}
                >
                  <option value="">Seleccione una nacionalidad</option>
                  {nacionalidades.map((n) => (
                    <option
                      key={n.idnacionalidad}
                      value={String(n.idnacionalidad)}
                    >
                      {n.nacionalidad}
                      {n.codigo ? ` (${n.codigo})` : ""}
                    </option>
                  ))}
                </select>
              </div>

              <div className="sm-field">
                <label>Pasaporte *</label>
                <input
                  value={this.state.pasaporte}
                  onChange={this.onChangeLimited("pasaporte", 30)}
                  placeholder="G12345678"
                  disabled={busy}
                />
              </div>

              <div className="sm-field">
                <label>Vía *</label>
                <select
                  value={this.state.via}
                  onChange={(e) => this.setState({ via: e.target.value })}
                  disabled={busy}
                >
                  <option value="">Seleccione una vía</option>
                  {VIA_OPTIONS.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="sm-field">
                <label>Locación *</label>
                <select
                  value={String(this.state.idlocacion || "")}
                  onChange={(e) => this.onLocSelect(e.target.value)}
                  disabled={busy}
                >
                  <option value="">Seleccione una locación</option>
                  {(this.state.locaciones || []).map((l) => (
                    <option key={l.idlocacion} value={String(l.idlocacion)}>
                      {l.locacion}
                    </option>
                  ))}
                </select>
              </div>

              <div className="sm-field">
                <label>Cantidad *</label>
                <input
                  value={this.state.cantidad}
                  onChange={this.onChangeCantidad}
                  placeholder="1000"
                  inputMode="decimal"
                  disabled={busy}
                />
              </div>

              <div className="sm-field">
                <label>Moneda *</label>
                <select
                  value={this.state.moneda}
                  onChange={(e) => this.setState({ moneda: e.target.value })}
                  disabled={busy}
                >
                  <option value="MXN">MXN</option>
                  <option value="USD">USD</option>
                </select>
              </div>

              <div className="sm-field">
                <label>Comentarios</label>
                <textarea
                  style={{
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    padding: "8px",
                    width: "100%",
                  }}
                  value={this.state.comentarios}
                  onChange={this.onChangeLimited("comentarios", 500)}
                  placeholder="Comentarios"
                  disabled={busy}
                  rows={5}
                />
              </div>

              <div className="sm-field">
                <label>Carpeta</label>
                <input
                  value={this.state.carpeta}
                  onChange={this.onChangeLimited("carpeta", 100)}
                  placeholder="Expediente"
                  inputMode="text"
                  disabled={busy}
                />
              </div>
            </div>

            <div className="sm-note">Campos con * son obligatorios.</div>
          </div>

          <div className="sm-foot">
            <button
              type="button"
              className="sm-btn ghost"
              onClick={onClose}
              disabled={busy}
            >
              Cancelar
            </button>

            <button
              type="button"
              className="sm-btn"
              onClick={this.onSubmit}
              disabled={busy}
            >
              {mode === "edit" ? "Guardar cambios" : "Guardar"}
            </button>
          </div>
        </div>
      </div>
    );
  }
}